/*
 * @Author: Dom
 * @Date: 2022-05-15 18:29:25
 * @LastEditTime: 2022-05-22 18:42:19
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\component\forgetpassword\locales\zh-CN.ts
 */
export default{
    'page.confirmtxt':'确定',
    'page.ctrltxt':'取消',
    'page.btnchangetxt':'换一换',
    'page.verificationtxt':'获取验证码',
    'page.verificationtxtrepeat':'重新获取验证码',
    'page.user.forgetpassword.email.tips':'输入需要找回密码的邮箱账号',
    'page.user.forgetpassword.email.required':'输入正确的邮箱帐号',
    'page.user.forgetpassword.emailtitle':'邮箱重置密码',
    'page.user.forgetpassword.phonetitle':'手机号重置密码',
    'page.user.forgetpassword.sendemailstart.tips':'请在发送邮件',
    'page.user.forgetpassword.sendtime.tips':'60分钟',
    'page.user.forgetpassword.sendemailend.tips':'内前往邮箱验证',
    'page.user.forgetpassword.sendemail.btntxt':'发送邮件',
    'page.user.forgetpassword.phonenumber.tips':'输入绑定手机号码',
    'page.user.forgetpassword.phonenumber.required':'输入正确手机号码',
    'page.user.forgetpassword.checknumber.tips':'输入图形验证码',
    'page.user.forgetpassword.checknumber.required':'请输入图形验证码',
    'page.user.forgetpassword.msgnumber.tips':'输入短信验证码',
    'page.user.forgetpassword.msgnumber.required':'请输入短信验证码',
    'page.user.forgetpassword.countdown.tips':'秒后重新发送',
    'page.user.forgetpassword.newpassword.tips':'设置新密码',
    'page.user.forgetpassword.newpassword.required':'请输入新密码',
    'page.user.forgetpassword.confirmpassword.tips':'确认新密码',
    'page.user.forgetpassword.confirmpassword.required':'再次输入密码',
    'page.user.forgetpassword.confirmpassword.required.compare':'两次密码不一致',
    'page.user.forgetpassword.phonecode.errormsg':'获取图形验证码失败!',
    'page.user.forgetpassword.smscode.errormsg':'短信发送失败!',
    'page.user.forgetpassword.smscode.msg':'短信已发出，请注意查收验证码!',
    'page.user.forgetpassword.email.msg':'邮件发送成功，请尽快登录邮箱验证!',
    'page.user.forgetpassword.email.errormsg':'发送邮件失败!',
    'page.user.forgetpassword.phone.msg':'密码找回成功!',
    'page.user.forgetpassword.phone.errormsg':'密码找回失败!',
}
